/**
 * Client-side contract search used by the Add-to-Group popup (ADO-715).
 * Matches contract number, supplier name, and owner/manager display names.
 */

export interface ContractSearchFields {
  contract_number?: string | null;
  supplier_name?: string | null;
  owner_names?: string | null;
  manager_names?: string | null;
}

export function matchesContractSearch(contract: ContractSearchFields, rawQuery: string): boolean {
  const query = rawQuery.trim().toLowerCase();
  if (!query) return true;

  const haystacks = [
    contract.contract_number,
    contract.supplier_name,
    contract.owner_names,
    contract.manager_names
  ];

  return haystacks.some((value) => value?.toLowerCase().includes(query));
}

export function joinPersonNames(people?: Array<{ name?: string | null }> | null): string {
  if (!people || people.length === 0) return '';
  return people
    .map((person) => person.name)
    .filter((name): name is string => Boolean(name))
    .join(' ');
}
